module.exports = __webpack_public_path__ + "static/img/historyPageStory.57c7c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/historyPageStory.jpg
// module id = E7hI
// module chunks = 3